export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/saxutlwq_SPS-01.png";

// Mockup-provided imagery
export const HERO_BG =
  "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/w3tuhkhh_1.webp"; // industrial bottling machinery

export const EMBLEM_METAL =
  "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/967kdq2l_AGAVE_WEB_SPS_4.webp"; // oval/teardrop emblem on navy bg

export const EMBLEM_CIRCLE =
  "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/mstogw0w_SPT-02.webp"; // silver agave emblem on black bg

export const AGAVE_PINAS =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_spirits-production/artifacts/7t04zcjv_IMAGENAGAVE-4.webp"; // agave 4 background

export const AGAVE_FIELD =
  "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/tvfz6czm_AGAVE_WEB_SPS.webp";

export const COMPANY = {
  name: "Spirits Production Services",
  short: "SPS",
  phone: "+52 3482440675",
  phoneHref: "+523482440675",
  email: "contacto@spiritsps.mx",
  address: "47775 Atotonilco el Alto, Jal.",
  instagram: "https://www.instagram.com/sps.corp/",
  facebook: "https://www.facebook.com/sps.corporativo/",
};

export const EMAILJS = {
  serviceId: "service_ocz2f8f",
  templateId: "template_tdd499e",
  publicKey: "w4kNqV46sLpBsChNJ",
};
